module.exports = __webpack_public_path__ + "media/images/logo-aleyria-868329a562955e573f36749555f89d8e.png";